const textListingDestruct = (registerText = {}) => {
  const {
    sign_up_message = '',
    free_account = '',
    live_go = '',
    register_better_radio = '',
    register_offer = '',
    register_offer_mobile = '',
    register_better_radio_details = '',
  } = registerText

  return {
    header: sign_up_message,
    items: [
      {
        icon:
          'https://www.tikilive.com/templates/v7-0-0/images/register/signup-user-icon.png',
        title: free_account,
        text: register_offer,
      },
      {
        icon:
          'https://www.tikilive.com/templates/v7-0-0/images/register/signup-mobile-icon.png',
        title: live_go,
        text: register_offer_mobile,
      },
      {
        icon:
          'https://www.tikilive.com/templates/v7-0-0/images/register/signup-user-icon.png',
        title: register_better_radio,
        text: register_better_radio_details,
      },
    ],
  }
}

export default textListingDestruct
